import { Consts } from '@/helpers/consts'

export const TuitionFeesAbleToPayMixin = {
  data() {
    return {
      firstPlateau: { firstAmount: '3 000', secondAmount: '6 000' },
      secondPlateau: { firstAmount: '7 000', secondAmount: '10 000' },
      thirdPlateau: { firstAmount: '11 000', secondAmount: '14 000' },
      fourthPlateau: { firstAmount: '15 000', secondAmount: '18 000' }
    }
  },
  methods: {
    getAmountWillingToPay: function() {
      let amountDictionnary = []

      amountDictionnary.push({
        label: this.$t('amount-willing-to-pay-not-able-to-pay', this.labelLanguage),
        value: Consts.AMOUNT_WILLING__TO_PAY_NOT_ABLE_TO_PAY
      })
      amountDictionnary.push({
        label: this.$t('amount-willing-to-pay-amounts', this.labelLanguage, this.firstPlateau),
        value: Consts.AMOUNT_WILLING__TO_PAY_THREE_SIX
      })
      amountDictionnary.push({
        label: this.$t('amount-willing-to-pay-amounts', this.labelLanguage, this.secondPlateau),
        value: Consts.AMOUNT_WILLING__TO_PAY_SEVEN_TEN
      })
      amountDictionnary.push({
        label: this.$t('amount-willing-to-pay-amounts', this.labelLanguage, this.thirdPlateau),
        value: Consts.AMOUNT_WILLING__TO_PAY_ELEVEN_FOURTEEN
      })
      amountDictionnary.push({
        label: this.$t('amount-willing-to-pay-amounts', this.labelLanguage, this.fourthPlateau),
        value: Consts.AMOUNT_WILLING__TO_PAY_FIFTEEN_EIGHTEEN
      })
      amountDictionnary.push({
        label: this.$t('amount-willing-to-pay-amounts-more-than', 'fr'),
        value: Consts.AMOUNT_WILLING__TO_PAY_MORE_THAN_NINETEEN
      })

      return amountDictionnary
    },
    profileTuitionFeesAbleToPay: function(tuitionFeesAbleToPay) {
      if (tuitionFeesAbleToPay === Consts.AMOUNT_WILLING__TO_PAY_NOT_ABLE_TO_PAY) {
        return this.$t('amount-willing-to-pay-not-able-to-pay', this.language)
      } else if (tuitionFeesAbleToPay === Consts.AMOUNT_WILLING__TO_PAY_THREE_SIX) {
        return this.$t('amount-willing-to-pay-amounts', this.language, this.firstPlateau)
      } else if (tuitionFeesAbleToPay === Consts.AMOUNT_WILLING__TO_PAY_SEVEN_TEN) {
        return this.$t('amount-willing-to-pay-amounts', this.language, this.secondPlateau)
      } else if (tuitionFeesAbleToPay === Consts.AMOUNT_WILLING__TO_PAY_ELEVEN_FOURTEEN) {
        return this.$t('amount-willing-to-pay-amounts', this.language, this.thirdPlateau)
      } else if (tuitionFeesAbleToPay === Consts.AMOUNT_WILLING__TO_PAY_FIFTEEN_EIGHTEEN) {
        return this.$t('amount-willing-to-pay-amounts', this.language, this.fourthPlateau)
      } else if (tuitionFeesAbleToPay === Consts.AMOUNT_WILLING__TO_PAY_MORE_THAN_NINETEEN) {
        return this.$t('amount-willing-to-pay-amounts-more-than')
      } else if (tuitionFeesAbleToPay === Consts.AMOUNT_WILLING__NA) {
        return this.$t('amount-willing-to-pay-amounts-na')
      } else {
        return ''
      }
    },
    getTuitionFeesAbleToPayFacetLabel: function(tuitionFeesAbleToPayFacet) {
      if (tuitionFeesAbleToPayFacet.value.toString() === Consts.AMOUNT_WILLING__NA) {
        return `${this.$t('amount-willing-to-pay-amounts-na')} (${tuitionFeesAbleToPayFacet.count})`
      }

      return `${this.getAmountWillingToPay().filter(x => x.value === tuitionFeesAbleToPayFacet.value.toString()).first().label} (${
        tuitionFeesAbleToPayFacet.count
      })`
    }
  }
}
